<script>
	import Stack from '$lib/Stack';
	import styles from './TOC.module.css';

	/** @type {Set<string>} */
	export let active;

	/** @type {string} */
	export let id;

	/** @type {string} */
	export let heading;

	/** @typedef {{ id: string, depth: number, heading: string, children: Section[] }} Section */
	/** @type {Section[]} */
	export let children;
</script>

<Stack as="li" gap="xs">
	<a class="{styles.link} {active.has(id) ? styles.active : ''}" href="#{id}">{heading}</a>
	{#if children.length}
		<Stack as="ol" class={styles.section}>
			{#each children as child}
				<svelte:self {active} {...child} />
			{/each}
		</Stack>
	{/if}
</Stack>
